import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { Box } from '../Box/index.js';

/* ======================================= */
const shimmer = keyframes(["0%{opacity:0.2;}50%{opacity:0.6;}100%{opacity:0.2;}"]);
const StyledBaseSkeleton = styled(Box).withConfig({
  displayName: "Skeleton__StyledBaseSkeleton",
  componentId: "sc-1mzmigm-0"
})(["animation:", " 1.6s linear infinite;"], shimmer);
/* ======================================= */
/**
 * SkeletonBlock is a large-sized block that is used to provide a low-fidelity
 * representation of the UI before content appears on the page.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/skeleton#usage)
 * - [Props](https://blockparty.endpoint.com/components/skeleton#props)
 * <br />
 *
 */
const SkeletonBlock = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledBaseSkeleton, _extends({
    ref: forwardedRef,
    bg: "carbon300",
    borderRadius: "radiusDefault",
    height: "24px",
    maxWidth: "10rem",
    width: "100%"
  }, rest), children);
});
/**
 * SkeletonText is a text block that is used to provide a low-fidelity
 * representation of the UI before content appears on the page.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/skeleton#usage)
 * - [Props](https://blockparty.endpoint.com/components/skeleton#props)
 * <br />
 *
 */
const SkeletonText = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    spacing = 'space60',
    lines = 3,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    _notFirst: {
      marginTop: spacing
    }
  }, rest), Array(lines).fill('').map((_line, i) => {
    const lastLine = lines === i + 1;
    return /*#__PURE__*/React__default.createElement(StyledBaseSkeleton, {
      key: i,
      bg: "carbon300",
      borderRadius: "radiusDefault",
      height: "8px",
      mb: lastLine ? 'space0' : 'space30',
      width: lastLine ? '80%' : '100%'
    }, children);
  }));
});

export { SkeletonBlock, SkeletonText };
